/* eslint-disable no-unused-vars */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

import { Window } from '../../00_IMMEDIATE/Window';
import { RequestHelp_Inventory } from './RequestHelp/RequestHelp_Inventory';
import { RequestHelp_InitiateButton } from './RequestHelp/RequestHelp_InitiateButton';
import { RequestHelp_Leaving } from './RequestHelp/RequestHelp_Leaving';
import { RequestHelp_Tutorial } from './RequestHelp/RequestHelp_Tutorial';
import { FriendshipChest_Countdown } from './FriendshipChest/FriendshipChest_Countdown';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { Window_FillRateFallback } from './Window_FillRateFallback';


/**
 * Class for pre-level screen
 * Some functionality is also being used by Window_dailyChallenge. Please watch out for that
 */
export default class Window_Level extends Window {
    /**
     * constructor
     * @param {Object} parent
     * @param {number} optLvlIndex
     * @param {Object} requestHelpData
     */
    constructor(parent, optLvlIndex, requestHelpData) {
        super(parent);

        this.isDailyChallenge = false;
        this._mysteryGift = false;
        this._requestHelpEnabled = OMT.feature.getFeatureRequestHelp();

        // the message we display to the player when they click on a disabled booster.
        this.disabledBoosterMessage = new Phaser.Group(this);

        this._manageData(optLvlIndex, requestHelpData);
        this._initLayout();
        this._initButtons();
        this._initStars();
        this._initTasks();
        this._initBoosters(requestHelpData);
        this._rh_setupInventory(optLvlIndex, requestHelpData);
        // only show friendship chest banner when request help is not active
        if (this._requestHelpEnabled) this._rh_setup(requestHelpData);
        else if (OMT.feature.getFeatureFriendshipChest(false)) this._initFriendshipChestBanner();
        this._setupTreasureHunt();
        //this._setupPostcardEvent(requestHelpData);
        this.add(this.disabledBoosterMessage);
        /* notify the game the level window is open */ // Just in case
        G.sb('levelWindowOpen').dispatch(G.lvlNr + 1, this.isDailyChallenge);

        this._boosters.forEach((booster) => {
            if (booster.isSelected()) {
                booster.deselect();
            }
        });
    }

    /**
     * we want to force the window to fit
     */
    update() {
        super.update();
        this.forceFitOnScreen();
    }

    /**
     * setup level data
     * @param {*} level
     */
    _manageData(optLvlIndex, requestHelpData) {
        this._parentLevelName = 'level';

        // set global level data
        if (optLvlIndex !== undefined) {
            G.lvlNr = optLvlIndex;
            G.lvlData = G.Helpers.levelDataMgr.getLevelByIndex(optLvlIndex);
        }
        this.levelData = G.lvlData;
        this._lvlIndex = G.lvlNr;
    }

    /**
     * init the generic graphics layout\
     * @param {*} headerTxt The text the header should have
     */
    _initLayout(headerTxt) {
        headerTxt = headerTxt || `${OMT.language.getText('Level')} ${G.lvlNr + 1}`;
        this._extraContainer = new Phaser.Group(game, this); // For some reason calling this.toLocal returns NaN but this.Group.toLocal is fine
        this._levelContainer = new Phaser.Group(game, this._extraContainer);
        
        if(G.lvlData.showAsHard && G.OMTsettings.global.jungleMatch)
            this.bg = G.makeImage(0, 0, 'popup_background_hard', 0.5, this._levelContainer);
        else
            this.bg = G.makeImage(0, 0, 'popup_background_2', 0.5, this._levelContainer);

        // banner for normal / hard level
        this._blue_banner = G.makeImage(
            0, -295,
            G.lvlData && G.lvlData.showAsHard ? 'blue_banner' : 'blue_banner',
            0.5,
            this._levelContainer,
        );

        // level title text
        this._levelTxt = new G.Text(0, -297, (headerTxt), {
            style: 'font-white',
            fontSize: '46px',
        }, 0.5, 260);
        this._levelContainer.add(this._levelTxt);

        // styling for a hard level
        if (G.lvlData && G.lvlData.showAsHard) {
            // this._hardIcon = G.makeImage(0, -350, 'map_point_hard', 0.5, this._levelContainer);
            // // this._hardIcon.scale.setTo(0.75);
            // if(G.OMTsettings.global.jungleMatch){
            //     this._hardIcon.visible = false;
            // }
            this._levelTxt.position.y = -310;
            this._hardWarningTxt = new G.Text(0, -275, OMT.language.getText('Hard Level'), {
                style: 'font-white',
                fontSize: '20px',
            }, 0.5);
            this._levelContainer.add(this._hardWarningTxt);
        }
    }

    /**
     * init window buttons
     * @param {*} buttonColor The color the continue button should be.
     * @param {*} onContinueClick the function that should run when the continue button is clicked.
     */
    _initButtons(buttonColor = BUTTONCOLOURS.green, onContinueClick) {
        // continue button
        const onClick = () => {
            if (this._requestHelpEnabled && this._requestHelpTutorialAppearance && this._requestHelpBtn) {
                this._rh_closeTutorial();
            }
            const levelData = {
                lvlIndex: this._lvlIndex,
                debugMode: false,
                startBoosters: this._assembleLevelBoosters(this._lvlIndex),
                challengeLvl: null,
                preLevelTrackingData: { requestHelp: this._rh_assembleTrackingData() },
            };
            G.sb('onStateChange').dispatch('Game', levelData); // G.lvlNr,false, temp, null, preLevelData);
        };

        onContinueClick = onContinueClick || onClick;
        // close button
        this._closeButton = new G.Button(235, -257, 'btn_x', this._checkLevelBonusesOnLeaving, this);
        this.registerButtons(this._closeButton);
        this._levelContainer.add(this._closeButton);


        this._continueBtn = new OMT_UI_SquareButton(0, 300, {
            button: {
                tint: buttonColor,
                dimensions: {
                    width: 196,
                    height: 100,
                },
            },
            text: {
                string: OMT.language.getText('Continue'),
                textStyle: { style: 'font-white', fontSize: 70 },
            },
            options: {
                clickFunction: {
                    onClick: onContinueClick.bind(this),
                },
            },
        });
        this.registerButtons(this._continueBtn);
        this._levelContainer.add(this._continueBtn);

        // using this.dailyChallengeLevel to ensure we don't run this when we're a daily challenge
        if (OMT.feature.canLevelShowAdContinueBooster() && !this.dailyChallengeLevel && !this.levelData.noPreBoosters) {
            this._makeAdContinueButton();
            if (this._adContBoosterButton) {
                this._adContBoosterButton.pulse(1.1);
            }
        } else {
            this._continueBtn.pulse(1.1);
        }
    }

    /**
     * create continue with booster for add button
     */
    _makeAdContinueButton() {
        const onAdClicked = () => {
            if (this._requestHelpEnabled && this._requestHelpTutorialAppearance && this._requestHelpBtn) {
                this._rh_closeTutorial();
            }

            const giveExtraBooster = (index, assembledBoosters) => {
                assembledBoosters.player[index] = true;
                G.saveState.changeBoosterAmount(index, 1, true); // Give one before you take one
            };

            const onAdSuccess = () => {
                const assembledBoosters = this._assembleLevelBoosters(this._lvlIndex);
                if (assembledBoosters.player[7] && !assembledBoosters.player[8]) { // Fixed to spiral bomb
                    giveExtraBooster(8, assembledBoosters);
                } else if (assembledBoosters.player[8] && !assembledBoosters.player[7]) { // Fixed to special gems
                    giveExtraBooster(7, assembledBoosters);
                } else { // Rng
                    const rng = Math.random();
                    if (rng < 0.5) {
                        giveExtraBooster(7, assembledBoosters);
                    } else {
                        giveExtraBooster(8, assembledBoosters);
                    }
                }

                const levelData = {
                    lvlIndex: this._lvlIndex,
                    debugMode: false,
                    startBoosters: assembledBoosters,
                    challengeLvl: null,
                    preLevelTrackingData: { requestHelp: this._rh_assembleTrackingData() },
                };
                G.sb('onStateChange').dispatch('Game', levelData); // G.lvlNr,false, temp, null, preLevelData);
            };
            sdkHandler.trigger('rewardedAd', {
                callback: (success) => {
                    if (success) { onAdSuccess(); } else { 
                        /* 'no more videos screen */
                        new Window_FillRateFallback(undefined, {
                                    placement: G.BuildEnvironment.adPlacements.preLevelBooster,
                                    callback: onAdSuccess,
                                    onExit: () => {},
                                    context: this,
                                  }); }
                }
            }, this);
            // OMT.ads.showAd(
            //   G.BuildEnvironment.adPlacements.preLevelBooster,
            //   onAdSuccess,
            //   () => {
            //     if (!G.IAP) { // no IAPS dont use ad fallbacks
            //       // eslint-disable-next-line no-new
            //       new Window_FillRateFallback(undefined, {
            //         placement: G.BuildEnvironment.adPlacements.preLevelBooster,
            //         callback: onAdSuccess,
            //         onExit: () => {},
            //         context: this,
            //       });
            //     } else { // open ad fallback
            //       if (this._rh_tutorialManager) {
            //         this._rh_tutorialManager.toggleVisibility(false);
            //       }
            //       OMT.ads.showAdFallback(() => {
            //         if (this._rh_tutorialManager) {
            //           this._rh_tutorialManager.toggleVisibility(true);
            //         }
            //         onAdSuccess();
            //       });
            //     }
            //   },
            // );
        };
        this._adContBoosterButton = new OMT_UI_SquareButton(0, 300, {
            button: {
                tint: BUTTONCOLOURS.purple,
                dimensions: {
                    width: 309,
                    height: 100,
                },
            },
            options: {
                clickFunction: {
                    onClick: onAdClicked.bind(this),
                },
                pulse: 1.1,
            },
        });

        const booster = new Phaser.Group(game, this._adContBoosterButton);
        const booster1 = G.makeImage(0, 0, G.gift.getIconForType(G.gift.GiftContentType.StartBoosterLines), 0.5, booster);
        const booster2 = G.makeImage(0, 0, G.gift.getIconForType(G.gift.GiftContentType.StartBoosterSpiralBomb), 0.5, booster);
        game.add.tween(booster1)
            .to({ alpha: 0 }, 1700, Phaser.Easing.Exponential.In, true, 500, null, true);
        booster2.alpha = 0;
        game.add.tween(booster2)
            .to({ alpha: 1 }, 1700, Phaser.Easing.Exponential.In, true, 500, null, true);
        booster.height = this._adContBoosterButton.height * 0.6;
        booster.width = this._adContBoosterButton.height * 0.6;
        const video = G.makeImage(booster.width * 0.6, booster.height / 2, 'btn-movie-icon', 0.5, booster);
        video.angle = -15;
        booster.x = (booster.width / 2) + 10 - (this._adContBoosterButton.width / 2);
        booster.y = -booster.height / 16;
        const leftoverSpace = (this._adContBoosterButton.width / 2) - (booster.x + booster.width) + 10;
        const continueText = new G.Text(0, 0, OMT.language.getText('Continue'), { style: 'font-white', fontSize: 70 }, 0.5, leftoverSpace, this._adContBoosterButton.height, true, 'center');
        continueText.x = booster.x + (booster.width * 0.65) + continueText.width / 2;
        this._adContBoosterButton.addChild(continueText);

        this.registerButtons(this._adContBoosterButton);
        this._levelContainer.add(this._adContBoosterButton);

        const centeringObjects = [this._continueBtn, this._adContBoosterButton];
        G.centerElements2(centeringObjects, 15);
        centeringObjects.forEach((obj) => { // Centers objects more a little bit
            obj.x += obj.width / 2;
        });
    }

    /**
     * display stars achived
     * @param {*} starsAchieved how many stars the player has achieved in that level.
     */
    _initStars(starsAchieved) {
        starsAchieved = starsAchieved || G.saveState.getStars(G.lvlNr);
        this._stars = [
            G.makeImage(-100, -150, starsAchieved >= 1 ? 'star' : 'star_blank', 0.5, this._levelContainer),
            G.makeImage(0, -175, starsAchieved >= 2 ? 'star' : 'star_blank', 0.5, this._levelContainer),
            G.makeImage(100, -150, starsAchieved >= 3 ? 'star' : 'star_blank', 0.5, this._levelContainer),
        ];
        this._stars[0].scale.setTo(0.8);
        this._stars[2].scale.setTo(0.8);
    }

    /**
     * init task UI
     */
    _initTasks() {
        let backgroundImage = 'popup_bigtext_backgr';
        let fontStyle = 'font-purple';

        if (G.lvlData.showAsHard && G.OMTsettings.global.jungleMatch) {
            backgroundImage = 'popup_text_backgr_hard';
            fontStyle = 'font-white';
        }

        this._taskBg = G.makeImage(0, 5, backgroundImage, 0.5, this._levelContainer);
        this._taskBg.scale.set(1, 1.2);
        this._taskTxt = new G.Text(0, -70, `${OMT.language.getText('Task')}:`, {
            style: fontStyle,
            fontSize: '45px',
        }, 0.5, 380);
        this._levelContainer.add(this._taskTxt);

        if (this.levelData.goal[0] === 'collect') {
            this._taskPanel = G.Helpers.createTaskCollectPanels(this.levelData.goal[1]);
            this._taskPanel.y = 5;
            this._levelContainer.add(this._taskPanel);
        } else {
            this._levelContainer.add(new G.Text(0, 5, `${OMT.language.getText('points').toUpperCase()}: ${this.levelData.goal[1]}`, {
                style: fontStyle,
                fontSize: '50px',
            }, 0.5, 380));
        }
    }

    /**
     * init booster and booster UI
     * @param {number} optLvlIndex
     * @param {Object} requestHelpData
     * @param {number} levelNumber the current level number
     */
    _initBoosters(requestHelpData, levelNumber, lvlData, isDailyChallenge) {
        let backgroundImage = 'popup_bigtext_backgr';
        let fontStyle = 'font-purple';

        if (G.lvlData.showAsHard && G.OMTsettings.global.jungleMatch) {
            backgroundImage = 'popup_text_backgr_hard';
            fontStyle = 'font-white';
        }

        const lvlNumber = levelNumber || G.lvlNr;
        const saveStateMgr = G.saveState;
        this._buyTxt = new G.Text(0, 90, ':', {
            style: fontStyle,
            fontSize: '35px',
        }, 0.5, 510);


        this.disableText = (new G.Text(0, 0, OMT.language.getText('This booster is disabled for this level.'), fontStyle));
        this.bgImage = new PhaserNineSlice.NineSlice(0, 0, 'treasure-hunt', 'th_tutorial_box', this.bg.width, this.disableText.height + 30, {
            left: 30,
            right: 30,
            bottom: 30,
            top: 30,
        });
        this.bgImage.x = -this.bgImage.width / 2;
        this.bgImage.y = -this.bgImage.height / 2;
        this.disabledBoosterMessage.add(this.bgImage);
        this.disabledBoosterMessage.add(this.disableText);

        this.disableText.width = this.bg.width - 50;
        this.disableText.scale.y = this.disableText.scale.x;

        this.bgImage.width = this.bg.width;
        this.bgImage.height = 60;

        this.disableText.x = -this.disableText.width / 2;
        this.disableText.y = -this.disableText.height / 2;


        this.disabledBoosterMessage.alpha = 0;

        const checkText = () => { // in scope of this._buyTxt
            if (!this.alive) return;
            const bst = saveStateMgr.data.boosters;
            const allActivate = bst[5] > 0 && bst[7] > 0 && bst[8] > 0;
            const allZero = bst[5] === 0 && bst[7] === 0 && bst[8] === 0;
            let newTxt;
            if (allActivate) {
                newTxt = `${OMT.language.getText('Activate boosters')}:`;
            } else if (allZero) {
                newTxt = `${OMT.language.getText('Buy some boosters')}:`;
            } else {
                newTxt = `${OMT.language.getText('Buy or activate boosters')}:`;
            }
            if (this._buyTxt.text !== newTxt) this._buyTxt.setText(newTxt);
        };

        this._buyTxt.checkText = checkText.bind(this._buyTxt);

        this._buyTxt.checkText();
        this._levelContainer.add(this._buyTxt);

        this._buyTxtBinding = G.sb('onStartBoosterSelectBounce').add(function() {
            G.stopTweens(this._buyTxt);
            this._buyTxt.checkText();
            this._buyTxt.scale.setTo(1);
            game.add.tween(this._buyTxt.scale)
                .to({ x: 1.2, y: 1.2 }, 200, Phaser.Easing.Custom.SoftBounce, true, 0, 0, true);
        }, this);

        this._buyTxt.events.onDestroy.add(function() {
            if (this._buyTxtBinding && this._buyTxtBinding.detach) {
                this._buyTxtBinding.detach();
            }
        }, this);

        this._boosterBg = G.makeImage(0, 170, backgroundImage, 0.5, this._levelContainer);

        let movesBoosterType = 5;
        if (G.IAP) {
            movesBoosterType = 6;
        }
        this._boosters = [
            new G.UI_StartBoosterButton(this, -195, 170, movesBoosterType, lvlNumber, isDailyChallenge, { layerName: this.parent.layerName, args: [lvlNumber, requestHelpData] }),
            new G.UI_StartBoosterButton(this, 0, 170, 7, lvlNumber, isDailyChallenge, { layerName: this.parent.layerName, args: [lvlNumber, requestHelpData] }, this.levelData.noPreBoosters),
            new G.UI_StartBoosterButton(this, 195, 170, 8, lvlNumber, isDailyChallenge, { layerName: this.parent.layerName, args: [lvlNumber, requestHelpData] }, this.levelData.noPreBoosters),
        ];

        if (this.levelData.noPreBoosters) {
            for (let i = 0; i < this._boosters.length; i++) {
                const booster = this._boosters[i];
                booster.onSelected = this._onBoosterSelected.bind(this);
            }
        }

        if (this.state.startBoosterConfig.data[movesBoosterType] && saveStateMgr.getBoosterAmount(movesBoosterType) > 0) {
            this._boosters[0].select();
        }
        if (this.state.startBoosterConfig.data[7] && saveStateMgr.getBoosterAmount(7) > 0) {
            this._boosters[1].select();
        }
        if (this.state.startBoosterConfig.data[8] && saveStateMgr.getBoosterAmount(8) > 0) {
            this._boosters[2].select();
        }

        this._levelContainer.addMultiple(this._boosters);
    }

    /**
     * when a booster has been selected
     */
    _onBoosterSelected(boosterBtn) {
        this.disabledBoosterMessage.y = this.bg.height / 2 + 100;
        this.disabledBoosterMessage.alpha = 0;
        if (boosterBtn.disabled) {
            // display the disabledBoosterMessage
            game.add.tween(this.disabledBoosterMessage).to({ y: this.bg.height / 2 + 60, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.Out, true);
        }
    }

    /**
     * setup treasure hunt feature
     */
    _setupTreasureHunt() {
        const { treasureHuntMgr } = G.TreasureHunt;
        const { TreasureHuntWindowPanel } = G.TreasureHunt;
        const popup = this;

        this._level_treasureHuntIsActive = treasureHuntMgr.isEventActive() &&
            treasureHuntMgr.isLevelTreasureHuntActive(this._lvlIndex) &&
            !(this._rh_inventoryIsShowing || this._requestHelpTutorialAppearance);

        if (!this._level_treasureHuntIsActive || this._requestHelpTutorialAppearance) return;

        this._blue_banner.changeTexture('Treasure_Hunt_header');

        popup.treasureHuntWindowPanel = this.add(new TreasureHuntWindowPanel({
            tutorial: true,
            scrollToFriends: true,
        }));
        this.y = this._mysteryGift ? 5 : -35;
        this.scale.setTo(this._mysteryGift ? 0.92 : 1);

        if (!this._requestHelpEnabled || !this._requestHelpBtn) { // If requestHelp is not here
            const onResize = () => {
                const extraOffset = ((game.height - 960) * 0.5) * 0.5;
                this.treasureHuntWindowPanel.y = 410 + extraOffset;
            };
            onResize(); // Otherwise the resize positioning func will be on this._rh_onWindowLevelResize
            G.Utils.cleanUpOnDestroy(this, G.sb('onScreenResize').add(onResize));
        }
    }

    /**
     * init the friendship chest banner
     */
    _initFriendshipChestBanner() {
        const predictedShownLevel = G.featureUnlock.unlockLevels.friendshipChest - G.saveState.getLastPassedLevelNr();
        if (!G.saveState.friendshipChestDataManager.getPromoInitial() && G.saveState.friendshipChestDataManager.getInvitedData() && predictedShownLevel > 0) {
            this.friendshipChestBanner = new FriendshipChest_Countdown(G.game, this);
            this.friendshipChestBanner.x = 320;
            this.friendshipChestBanner.visible = false;
            this.friendshipChestBanner.toggleVisibility(true);
            const goodPos = this._extraContainer.toLocal(this.friendshipChestBanner.position, this._extraContainer);
            this._levelContainer.y = goodPos.y + 10 + this.friendshipChestBanner.renderedBounds.height / 2;
        }
    }

    /**
     * add the myster gift header
     */
    _addMysteryGiftHeader() {
        const mysteryGiftHeader = new G.MysteryGiftHeader(this._lvlIndex === G.saveState.getLastPassedLevelNr());
        mysteryGiftHeader.show();
        this.onClose.add(() => {
            mysteryGiftHeader.hide(() => {
                mysteryGiftHeader.destroy();
            });
        });
    }

    /**
     * check level bonsues on leaving pre-level screen
     */
    _checkLevelBonusesOnLeaving() {
        const requestInventoryIsOkToLeave = this._rh_checkBoostersUponLeaving();
        if (requestInventoryIsOkToLeave) {
            this._closeLevel();
        }
    }

    /**
     * Hides extra UI but doesn't close the window itself
     */
    _closeLevelTemporarily() {
        if (this._requestHelpEnabled && this._requestHelpBtn && G.saveState.requestHelp_getTutorialStep() > -1) {
            this._rh_closeTutorial();
        }

        if (this._requestHelp_inventory) this._requestHelp_inventory.toggleInventory(false, true);
        if (this.friendshipChestBanner) this.friendshipChestBanner.toggleVisibility(false, true);

        this._boosters.forEach(function(btn) {
            if (btn.signalBinding) btn.signalBinding.detach();
        });
    }

    /**
     * close the level popup
     */
    _closeLevel() {
        this._closeLevelTemporarily();

        if (game.state.current === 'Game') {
            G.sb('onStateChange').dispatch('World');
            return;
        }

        this._boosters.forEach((booster) => {
            if (booster.isSelected()) {
                booster.deselect();
            }
        });

        this.closeWindow();
        G.sb('levelWindowClose').dispatch();
    }

    /**
     * setup boosters to apply to the level
     * @param {number} level
     */
    _assembleLevelBoosters(level) {
        let reqHelpBooster = [];
        if (this._requestHelp_inventory) {
            reqHelpBooster = this._requestHelp_inventory.getInventory();
        }
        const startBoosters = {
            player: this.state.startBoosterConfig.getConfigForLevel(level), // State is world
            requestHelp: reqHelpBooster,
        };
        return startBoosters;
    }

    /**
     * setup request help inventory
     * @param {Object} requestHelpData
     */
    _rh_setupInventory(levelData, requestHelpData) {
        // Used by requestHelp to come back
        this._levelArguments = levelData;
        // init request help inventory
        const saveStateMgr = G.saveState;
        if (this._requestHelpEnabled) {
            if (!(requestHelpData && requestHelpData.inventory)) {
                this._requestHelp_inventory = new RequestHelp_Inventory();
            } else {
                this._requestHelp_inventory = requestHelpData.inventory;
            }
            if (saveStateMgr.requestHelp_getTutorialComplete() >= 10 && saveStateMgr.requestHelp_getTutorialAppearance() === 0) {
                if (!requestHelpData) { requestHelpData = {}; }
                requestHelpData.showPointer = true;
            }
        }
        // only add mystery gift header if request help inventory is not showing
        this._rh_inventoryIsShowing = this._requestHelpEnabled && this._requestHelp_inventory && this._requestHelp_inventory.items.length > 0;
        if (!this._rh_inventoryIsShowing) {
            if (G.MYSTERYGIFT && saveStateMgr.mysteryGift_isModeReady() && saveStateMgr.mysteryGift_getRemainingGiftCooldown() > 0) {
                this._mysteryGift = true;
                this._addMysteryGiftHeader();
                this.y = game.state.current === 'Game' ? 0 : 45;
            }
        }
        // Checking if the tutorial should appear
        this._requestHelpTutorialAppearance = this._requestHelpEnabled && saveStateMgr.requestHelp_shouldTutorialShow() && saveStateMgr.requestHelp_getTutorialStep() === 0;
    }

    /**
     * setup request help features
     * @param {Object} requestHelpData
     */
    _rh_setup(requestHelpData) {
        if (this._rh_inventoryIsShowing) {
            this.add(this._requestHelp_inventory.display);
            this._requestHelp_inventory.toggleInventory(true);

            G.Utils.cleanUpOnDestroy(this._levelContainer, G.sb('onScreenResize').add(() => { this._rh_onWindowLevelResize(); })); // Resize func
            this._rh_onWindowLevelResize(); // Positioning
        } else {
            this.onFinishedEnter.addOnce(() => { this._rh_onWindowLevelResize(); }); // Just in time!?

            this._rh_createRequestHelp(this._levelArguments, () => {
                if (this._requestHelpTutorialAppearance) {
                    this._rh_tutorialManager = new RequestHelp_Tutorial(G.Game);
                    this._rh_tutorialManager.setTarget({
                        display: this,
                        target: this._requestHelpBtn,
                        offset: { x: this._requestHelpBtn.renderedBounds.width * 0.3, y: 0 },
                    });
                    this._rh_tutorialManager.displayMsg(G.json.tutorials.RequestHelpTutorial.preLevel);
                } else if (requestHelpData && requestHelpData.showPointer) {
                    this._pointerHand = new Phaser.Group(requestHelpData.game, game.world);
                    const handImg = G.makeImage(0, 20, 'tut_hand', 0, this._pointerHand); // Taken from G.DailyIcon
                    game.add.tween(handImg).to({ x: G.l(20), y: G.l(50) }, 300, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);
                    this._pointerHand.update = () => {
                        if (this._requestHelpBtn) { // incase it destroys itself or something
                            const goodPos = game.world.toLocal(this._requestHelpBtn, this);
                            goodPos.x += this._requestHelpBtn.renderedBounds.width * 0.3;

                            if (!this._pointerHand.position.equals(goodPos)) {
                                this._pointerHand.position.set(goodPos.x, goodPos.y);
                            }
                        } else {
                            this._pointerHand.visible = false;
                            this._pointerHand.update = () => {};
                        }
                    };
                }
                G.Utils.cleanUpOnDestroy(this._requestHelpBtn, G.sb('onScreenResize').add(() => { this._rh_onWindowLevelResize(); })); // Resize func
                this._rh_onWindowLevelResize(); // Positioning
            });
        }
    }

    /**
     * Creates the button to go into RequestHelp Window
     * Used in window_level and window_dailyChallenge. It could be anything.
     * Just something to pass back into the window to be remade
     * @param {any} currentLevel
     */
    async _rh_createRequestHelp(currentLevel, onCreation) {
        this._requestHelpBtn = new RequestHelp_InitiateButton(G.Game, this, {
            onButtonDown: () => {
                if (this._requestHelpEnabled && G.saveState.requestHelp_getTutorialStep() > -1) { // Close tutorial
                    this._rh_closeTutorial(false);
                }

                this.closeWindow(); // Close window_level
                G.sb('hideHighscoreBoard').dispatch(); // Triggers G.sb in World.js
                G.sb('pushWindow').dispatch(['requestHelp', { // Opens requestHelp
                        parentName: this._parentLevelName,
                        currentLevelData: currentLevel,
                        inventory: this._requestHelp_inventory,
                    }],
                    false,
                    this.parent.layerName);
            },
            creationCallback: onCreation,
        });
    }

    /**
     * Resize function
     */
    _rh_onWindowLevelResize() {
        if (this._requestHelpEnabled) {
            const activeObject = this._requestHelpBtn ? this._requestHelpBtn : this._requestHelp_inventory;
            const activeContainer = this._requestHelpBtn ? this._requestHelpBtn : this._requestHelp_inventory.display;
            let safePosition = 0;
            let spaceBetween = 0;

            if (this._rh_tutorialManager) {
                this._levelContainer.y = this._rh_tutorialManager.getLevelWindowSpecificOffset(); // After tons of math it simplified to this...

                safePosition = this._levelContainer.y + (activeObject.renderedBounds.height + this._levelContainer.height) / 2;
                spaceBetween = ((game.height - this._rh_tutorialManager.renderedBounds.height) - safePosition) / 2;
            } else if (this._level_treasureHuntIsActive) {
                safePosition = -10 + this._levelContainer.y + (activeObject.renderedBounds.height + this._levelContainer.height) / 2;
                spaceBetween = (game.height - safePosition) / 2;
            } else {
                safePosition = this._levelContainer.y + (activeObject.renderedBounds.height + this._levelContainer.height) / 2;
                spaceBetween = (game.height - safePosition) / 2;
            }

            activeContainer.y = Math.max(safePosition, (safePosition + spaceBetween) / 2); // Either close, but not overlapping, or between button to height
            if (!this._rh_tutorialManager && this._level_treasureHuntIsActive) {
                this.treasureHuntWindowPanel.y = activeContainer.y + 10 + (activeObject.renderedBounds.height + this.treasureHuntWindowPanel.height) / 2;
            }
        }
    }

    /**
     * Checks if its ok to leave the preLevel screen
     * If it is not ok to leave, it'll create the extra window to make sure the user wants to
     */
    _rh_checkBoostersUponLeaving() {
        let isItFineToLeave = true;
        if (this._rh_inventoryIsShowing) {
            // Are you sure???
            // eslint-disable-next-line no-new
            new RequestHelp_Leaving(G.Game, this.parent, {
                inventory: this._requestHelp_inventory,
                scale: this.scale,
                onExit: () => {
                    const evntData = this._rh_assembleTrackingData();
                    DDNA.tracking.collectEvent('requestHelpCanceled', evntData);
                    this._closeLevel(); // Goes through necessary things before closing
                },
            });

            isItFineToLeave = false; // Its not fine to leave
        }
        return isItFineToLeave;
    }

    /**
     * Hides it and destroys
     */
    _rh_closeTutorial(completelyLeavingLevel = true) {
        if (this._rh_tutorialManager) {
            this._rh_tutorialManager.close();
        }
        // If tutorial is still needed
        if (completelyLeavingLevel) {
            if (G.saveState.requestHelp_getTutorialAppearance() === 0) {
                switch (G.saveState.requestHelp_getTutorialStep()) {
                    case 1:
                    case 0:
                        G.saveState.requestHelp_setTutorialReappearance(0);
                        break;
                    case 2:
                        G.saveState.requestHelp_setTutorialReappearance(3);
                        break;
                    case -1:
                        break;
                    default:
                        break;
                }
            }
        }
        this._rh_destroyPointerHand(completelyLeavingLevel);
    }

    /**
     * destory request help pointer hand
     * @param {boolean} completelyLeavingLevel
     */
    _rh_destroyPointerHand(completelyLeavingLevel = true) {
        if (this._pointerHand) {
            if (this._pointerHand.parent) {
                this._pointerHand.parent.removeChild(this._pointerHand);
            }
            this._pointerHand.destroy();

            // if (completelyLeavingLevel && G.saveState.requestHelp_getTutorialAppearance() === 0) {
            //   G.saveState.requestHelp_setTutorialReappearance(3);
            // }
        }
    }

    /**
     * Returns data for DeltaDNA
     * @returns {Object}
     */
    _rh_assembleTrackingData() {
        let rtr;

        if (this._requestHelpEnabled) {
            let boosterLength = 0;
            if (this._requestHelp_inventory) {
                boosterLength = this._requestHelp_inventory.items.length;
            }

            const trackingData = this._requestHelp_inventory ? this._requestHelp_inventory.trackingData : null;
            rtr = {
                mRequestHelpUniqueFriends: G.saveState.requestHelp_getUniqueFriendCount(),
                mRequestHelpMessages: trackingData ? trackingData.numberOfMessages : 0,
                mRequestHelpIsBot: (trackingData && trackingData.askedBotThisLevel) ? 1 : 0,
                mRequestHelpBoosterForLevel: boosterLength,
                mRequestHelpOpened: G.saveState.requestHelp_getOpened(),
            };
        } else {
            rtr = {};
        }
        return rtr;
    }

    /**
     * Checks if the postcard event is active, and then creates a button next to the level banner in the window
     * The requestHelpData is for when returning to the level window
     * @param {Object} requestHelpData
     */
    async _setupPostcardEvent(requestHelpData) {
        const featureOk = await OMT.feature.getEventPostcardFeature(true);
        if (OMT.feature.getEventPostcardAssetStatus()) {
            if (featureOk) {
                const onPostcardClicked = () => {
                    const returnArgs = { windowName: 'level', args: [this._lvlIndex, requestHelpData], layerName: this.parent.layerName };
                    if (G.saveState.isMsgRead(G.OMTsettings.postcardEvent.eventId)) {
                        G.sb('pushWindow').dispatch(['eventPostcard', returnArgs], false, this.parent.layerName);
                    } else {
                        G.sb('pushWindow').dispatch(['eventPostcardPromo', returnArgs], false, this.parent.layerName);
                    }
                    G.sb('hideHighscoreBoard').dispatch(); // Triggers G.sb in World.js
                    this._closeLevelTemporarily();
                    this.closeWindow();
                };

                this._postcardButton = new G.Button(0, 0, null, onPostcardClicked, this);
                this.registerButtons(this._postcardButton);

                G.makeImage(0, 0, 'eventPostcardIcon', 0.5, this._postcardButton);
                this._postcardButton.x = Math.round(this._blue_banner.x - this._postcardButton.width - (this._blue_banner.width / 2));
                this._postcardButton.y = this._blue_banner.y;
                this._postcardButton.scale.set(0.01);

                this._levelContainer.addChild(this._postcardButton);

                const tw = game.add.tween(this._postcardButton.scale)
                    .to({ x: 1, y: 1 }, 200, Phaser.Easing.Back.Out, true);
                const shake = game.add.tween(this._postcardButton)
                    .to({ angle: [0, -5, 5, 0] }, 1000, Phaser.Easing.Sinusoidal.In, true, 0, 0, true);
                const subtlePause = game.add.tween(this._postcardButton)
                    .to({ angle: 0 }, 500, Phaser.Easing.Sinusoidal.In);
                tw.chain(shake);
                shake.chain(subtlePause);
                subtlePause.chain(shake);
            }
        }
    }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.level = Window_Level;